import { events } from "artisn/analytics";

import { LogAddProductToCart } from "types/analytics/shoppingCartEvents.types";

const { shoppingCart } = events;
const { logAddProductToCart: logAddProductToCartSdk } = shoppingCart;

export const logAddProductToCart = (params: LogAddProductToCart) => {
  logAddProductToCartSdk(params);
};
